export enum LOCAL_STORAGE_STORE_CONSTANTS {
    X_USER = 'X_USER',
}

export const COMPANY_ADDRESS = { lat: 40.4354, lng: -74.21042 };
